var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedium(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#iconMedium_svg__paint0_linear_4146_5512)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconMedium_svg__clip0_4146_5512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.42 27.86v.336l-9.725 9.759a.39.39 0 01-.458-.07l-4.044-4.028-3.975 4.002c-.181.188-.431.188-.613 0-2.404-2.409-4.776-4.851-7.184-7.256-.678-.677-1.635-1.443-2.222-2.182-.15-.19-.253-.304-.17-.564l9.576-9.716c.182-.188.432-.188.613 0l3.975 4.002 4.043-4.028a.39.39 0 01.458-.07l9.726 9.815h0zm-18.508-8.792l-8.848 8.98 8.848 8.884 3.69-3.723-4.972-5.067c-.068-.189.061-.365.17-.507l4.802-4.844-3.69-3.723zm8.602 0l-3.69 3.723 4.802 4.844.185.464-4.986 5.11 3.69 3.723 8.848-8.884-8.849-8.98zm.25 9.015l-4.53-4.644-4.57 4.56 4.53 4.561 4.57-4.477h0z",
    fill: "#058181",
    stroke: "#058181",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconMedium_svg__paint0_linear_4146_5512",
    x1: 27.5,
    y1: 0,
    x2: 27.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F4FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iconMedium_svg__clip0_4146_5512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 18)",
    d: "M0 0h28.421v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconMedium.3305db40.svg";
export { MemoForwardRef as ReactComponent };